// Shared schema.org entities for the public pages. Kept free of '@/' imports so the e2e
// unit tests, whose tsconfig has no alias, can import it.

/** TaskEye, the brand every public page is about. */
export const TASKEYE_BRAND = { '@type': 'Brand', name: 'TaskEye', url: 'https://taskeye.com' } as const;

/**
 * Who provides every TaskEye service: Cano Partners, under the TaskEye brand. This is the
 * site footer's own wording ("TaskEye is a product of Cano Partners"), and pairing the two
 * names tells search engines and AI tools this TaskEye apart from Uffizio's field-tracking
 * app of the same name.
 */
export const TASKEYE_PROVIDER = {
  '@type': 'Organization',
  name: 'Cano Partners',
  brand: TASKEYE_BRAND,
} as const;

/** The home page's entity: the same organisation and brand, with what TaskEye does. */
export const HOME_ORGANIZATION_JSONLD = {
  '@context': 'https://schema.org',
  ...TASKEYE_PROVIDER,
  description:
    'TaskEye, a product of Cano Partners, runs SOP checklists, field visits and team tasks on WhatsApp. Built for restaurants and hospitality, manufacturing, events, and field sales teams.',
} as const;
